import CompanyBillingViewController from './CompanyBillingViewController';

export default CompanyBillingViewController;
